// extracted by mini-css-extract-plugin
module.exports = {"cart-item":"CartItem_cart-item__PsFj5","summary":"CartItem_summary__9KgxS","price":"CartItem_price__2agtj","amount":"CartItem_amount__2abbn","actions":"CartItem_actions__H4FWI"};